<!--  -->
<template>
  <div class="ji_box">
    <div class="search_box">
      <el-input v-model="keywords" placeholder="请输入员工名称/编号" style="width:300px" />
      <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchr">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" @click="reastr">重置</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="name"
        label="姓名(公司名称)"
        width="400"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.name }}({{ scope.row.corp_name }})
        </template>
      </el-table-column>
      <el-table-column
        prop="employee_no"
        label="员工编号"
        width="300"
        align="center"
      />
      <el-table-column
        prop="address"
        label="进度"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <el-progress :text-inside="true" :stroke-width="20" :percentage="parseInt(scope.row.count/scope.row.max_count * 100)" status="success" />
        </template>
      </el-table-column>
      <el-table-column
        prop="count"
        label="未发送消息数量"
        width="200"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="aerwr(scope.row.employee_no)">清除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { messagePushUpindex, messagePushUpclear } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      input: '',
      tableData: [],
      keywords: null,
      max: null,
      loading: false
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  activated() {
    this.list()
  },
  methods: {
    async list() {
      this.loading = true
      const data = await messagePushUpindex({
        keywords: this.keywords
      })
      if (data.data === null) {
        this.tableData = []
      } else {
        this.tableData = data.data
      }
      this.loading = false
      if (this.max === null) {
        this.max = this.tableData[0].count
      }
      console.log(data)
    },
    aerwr(employee_no) {
      this.$confirm('此操作将清除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        messagePushUpclear({
          employee_no: employee_no
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '清除成功!'
          })
          this.list()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消清除'
        })
      })
    },
    format(percentage) {
      return percentage === 100 ? '满' : `${percentage}%`
    },
    searchr() {
      this.list()
    },
    reastr() {
      this.keywords = null
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.ji_box{
  padding: 30px;
}
.search_box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
